import moment from 'moment';
import { clsx } from 'clsx';
import { MarkdownRenderer } from 'src/components/MarkdownRenderer/MarkdownRenderer';
import { AddFAQPopup } from 'src/components/KnowledgeBase/AddFAQPopup/AddFAQPopup';
import { useParams } from 'react-router-dom';

export const PlaygroundUserMessage = ({ className, message, ...props }) => {
  const { id } = useParams();

  return (
    <li
      className={clsx('group/user-message flex flex-col items-end gap-[5px]', className)}
      {...props}
    >
      <div className="flex flex-col items-end gap-[5px] w-full md:max-w-[90%] lg:max-w-[90%] xl:max-w-[90%]">
        <div
          className={
            '[&_p:last]:mb-0 [&_p:last-of-type]:mb-0 message-bg bg-light p-4 rounded-sm-5 text-ebony_opacity_70 text-sm font-normal border border-[#E3E6E880]'
          }
        >
          <MarkdownRenderer>{message.body}</MarkdownRenderer>
        </div>
        <div className={'flex flex-row justify-between gap-2.5 items-center'}>
          <span
            className={
              'text-ebony_opacity_30 text-[0.688rem] font-medium opacity-0 group-hover/user-message:opacity-100 transition-opacity duration-300'
            }
          >
            {moment(moment.utc(message.created_at).toDate()).format('hh:mm A')}
          </span>
          <AddFAQPopup projectId={id} message={message.body} />
        </div>
      </div>
    </li>
  );
};
